export function evaluateExpression (expression, context) {
  var expressionFunc = new Function('expression', 'context', 'with (context) { return eval(expression) }')

  return expressionFunc(expression, context)
}
